import React from 'react'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip placement='top' {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'rgba(48, 48, 81, 0.95)'
    // scale: '2',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgba(48, 48, 81, 0.95)',
    padding: '16px 20px',
    fontSize: '14px',
    fontFamily: 'Plus Jakarta Sans',
    lineHeight: '22px'
  }
}))

const Info = ({ text, style }) => {
  return (
    <BootstrapTooltip title={text}>
      <svg
        style={{ marginLeft: '8px', marginRight: '14px', ...style }}
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          opacity='0.1'
          d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
          fill='#8D8D94'
        />
        <path
          d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
          stroke='#8D8D94'
          strokeWidth='0.833333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z'
          fill='#8D8D94'
        />
        <path
          d='M10 11.25V10.625C10.4326 10.625 10.8556 10.4967 11.2153 10.2563C11.575 10.016 11.8554 9.67433 12.021 9.27462C12.1866 8.87491 12.2299 8.43507 12.1455 8.01074C12.0611 7.58641 11.8527 7.19663 11.5468 6.89071C11.2409 6.58478 10.8511 6.37644 10.4268 6.29203C10.0024 6.20763 9.56259 6.25095 9.16288 6.41651C8.76317 6.58208 8.42153 6.86246 8.18116 7.22219C7.94079 7.58192 7.8125 8.00485 7.8125 8.4375'
          stroke='#8D8D94'
          strokeWidth='0.833333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </BootstrapTooltip>
  )
}

export default Info
